var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Video"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 6.5H4.5C3.94772 6.5 3.5 6.94772 3.5 7.5V16.5C3.5 17.0523 3.94772 17.5 4.5 17.5H13.5C14.0523 17.5 14.5 17.0523 14.5 16.5V14.0212C14.4997 14.0065 14.4997 13.9917 14.5 13.977V10.023C14.4997 10.0083 14.4997 9.99357 14.5 9.97886V7.5C14.5 6.94772 14.0523 6.5 13.5 6.5ZM16.5 16.5V15.7411L19.4922 17.4865C20.8255 18.2643 22.4999 17.3026 22.4999 15.759V8.24105C22.4999 6.69747 20.8255 5.73572 19.4922 6.51349L16.5 8.25893V7.5C16.5 5.84315 15.1569 4.5 13.5 4.5H4.5C2.84315 4.5 1.5 5.84315 1.5 7.5V16.5C1.5 18.1569 2.84315 19.5 4.5 19.5H13.5C15.1569 19.5 16.5 18.1569 16.5 16.5ZM20.4999 15.759L16.5 13.4257V10.5743L20.4999 8.24105L20.4999 15.759ZM6 8C5.44772 8 5 8.44772 5 9C5 9.55228 5.44772 10 6 10H8C8.55228 10 9 9.55228 9 9C9 8.44772 8.55228 8 8 8H6Z",
    fill: "#006B6B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideo);
export default __webpack_public_path__ + "static/media/ic_video.9f0e194042818c57da7936e04e890c7e.svg";
export { ForwardRef as ReactComponent };